export enum Button {
  DEFAULT = 'btn-default',
  PRIMARY = 'btn-primary',
  DANGER = 'btn-danger',
  SUCCESS = 'btn-success'
}

export enum Icon {
  REFRESH = 'fa-refresh',
  PLUS = 'fa-plus'
}

export enum Alert {
  DANGER = 'alert-danger',
  WARNING = 'alert-warning',
  SUCCESS = 'alert-success'
}